<template>
  <div>
    <AnnouncementEditorPage
      v-if="$route.path == '/console/announcement/edit'"
    />
    <MailTemplateListPage v-if="$route.path == '/console/mail/templateList'" />
    <QQGroupListPage v-if="$route.path == '/console/misc/qqgroups'" />
    <CloudArchivePage v-if="$route.path == '/console/cloudArchive/recover'" />
    <RedeemCodeManagePage v-if="$route.path == '/console/redeem-code'" />
    <BlackListPage v-if="$route.path == '/console/misc/blacklist'" />
    <GreyListPage v-if="$route.path == '/console/misc/greylist'" />
    <WhiteListPage v-if="$route.path == '/console/misc/whitelist'" />
    <ClientLogQueryPage v-if="$route.path == '/console/misc/clientlog'" />
    <SensitiveWordListPage
      v-if="$route.path == '/console/misc/sensitivewords'"
    />
    <PictureListPage v-if="$route.path == '/console/picture'" />
    <FunctionSwitchListPage
      v-if="$route.path == '/console/function-switch/list'"
    />
    <VersionListPage v-if="$route.path == '/console/version/list'" />
    <ZoneListPage v-if="$route.path == '/console/zone/list'" />

    <Dialogs />
  </div>
</template>

<script>
import AnnouncementEditorPage from "@/pages/announcement/AnnouncementEditorPage";
import MailTemplateListPage from "@/pages/mail/MailTemplateListPage";
import QQGroupListPage from "@/pages/qqGroup/QQGroupListPage";
import CloudArchivePage from "@/pages/cloudArchiv/uploadAndDownload";
import BlackListPage from "@/pages/blackList/BlackListPage";
import GreyListPage from "@/pages/greyList/GreyListPage";
import WhiteListPage from "@/pages/whiteList/WhiteListPage";
import SensitiveWordListPage from "@/pages/sensitiveWord/SensitiveWordListPage";
import PictureListPage from "@/pages/picture/PictureListPage";
import ClientLogQueryPage from "@/pages/clientLog/ClientLogQueryPage";
import FunctionSwitchListPage from "@/pages/function-switch/FunctionSwitchListPage";
import VersionListPage from "@/pages/version/VersionListPage";
import ZoneListPage from "@/pages/zone/ZoneListPage";
import RedeemCodeManagePage from "@/pages/redeem-code/RedeemCodeManagePage";
import Dialogs from "./Dialogs";

export default {
  data() {
    return {};
  },

  components: {
    Dialogs,
    AnnouncementEditorPage,
    MailTemplateListPage,
    QQGroupListPage,
    CloudArchivePage,
    BlackListPage,
    GreyListPage,
    WhiteListPage,
    SensitiveWordListPage,
    PictureListPage,
    ClientLogQueryPage,
    FunctionSwitchListPage,
    VersionListPage,
    ZoneListPage,
    RedeemCodeManagePage,
  },

  methods: {},
};
</script>